import { createGTMEvent } from '../../core/ecommerceMapper';
import type { GTMEventName } from '../../types';

const CONSENT_EVENTS = {
    OneTrustLoaded: 'OneTrustLoaded',
    OptanonLoaded: 'OptanonLoaded',
    OneTrustGroupsUpdated: 'OneTrustGroupsUpdated',
} as const satisfies Record<string, GTMEventName>;

const ALWAYS_INCLUDED_GTM_CODES = ['C0001', 'C0002'];
const QUERY_ALLOWED_GTM_CODES = ['C0003', 'C0004'];

const getAllowedConsentCodes = (codes: string[]) => {
    const normalizedQueryCodes = codes
        .map((code) => code.toUpperCase())
        .filter((code) => QUERY_ALLOWED_GTM_CODES.includes(code));

    return [...new Set([...ALWAYS_INCLUDED_GTM_CODES, ...normalizedQueryCodes])];
};

const formatConsentCodes = (codes: string[]) => `,${codes.join(',')},`;

const createConsentEvent = (
    event: GTMEventName,
    propertyName: 'OnetrustActiveGroups' | 'OptanonActiveGroups',
    codes: string[],
) =>
    createGTMEvent(event, {
        [propertyName]: formatConsentCodes(getAllowedConsentCodes(codes)),
    });

export const createOneTrustLoadedEvent = (codes: string[]) =>
    createConsentEvent(CONSENT_EVENTS.OneTrustLoaded, 'OnetrustActiveGroups', codes);

export const createOptanonLoadedEvent = (codes: string[]) =>
    createConsentEvent(CONSENT_EVENTS.OptanonLoaded, 'OptanonActiveGroups', codes);

export const createOneTrustGroupsUpdatedEvent = (codes: string[]) =>
    createConsentEvent(CONSENT_EVENTS.OneTrustGroupsUpdated, 'OnetrustActiveGroups', codes);
